var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"userinfor"},[_c('p',{staticClass:"txt_align"},[_c('span',{staticClass:"gray"},[_vm._v(" "+_vm._s(_vm.getUserInfor))]),_vm._v("\n\t\t    \n\t\t"),_c('span',{staticClass:"red"},[_vm._v(_vm._s(_vm.protectLogin))])])])}
var staticRenderFns = []

export { render, staticRenderFns }